import React, { useEffect } from 'react'
import { render } from 'react-dom'
import Leaflet from 'leaflet';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import { useHistory } from "react-router-dom";



Leaflet.Icon.Default.imagePath = '../node_modules/leaflet';
delete Leaflet.Icon.Default.prototype._getIconUrl;

Leaflet.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

const position = [23, 55]

const locations =[
  { id: '1', name: 'Adnoc', position: [24.4792951,54.344354]},
  { id: '2', name: 'Dhaid', position: [25.2999938,55.9558873]},
  { id: '3', name: 'Hatta', position: [24.8106093,56.0768879]},
  { id: '4', name: 'Jabel Hafeet', position: [24.0566826,55.777073]},
  { id: '5', name: 'MOPA', position: [24.4533794,54.3167099]},
  { id: '6', name: 'NCM HQ', position: [224.3383579,54.6389123]},
  { id: '7', name: 'Shuwaib', position: [24.7558259,55.7849093]},
  { id: '8', name: 'SkyTower', position: [24.4962622,54.4086913]},
]

export default () =>{
  const history = useHistory();

  const openLocation = (l) => {
    console.log('l',l);
    history.push('/location')
  }

  useEffect(() => {

    let vHeight = window.innerHeight;
    document.documentElement.style.setProperty('--vHeight', `${vHeight}px`);

    window.addEventListener('resize', () => {
      let vHeight = window.innerHeight;
      document.documentElement.style.setProperty('--vHeight', `${vHeight}px`);
    })
  },[]);

  return(
    <Map id="LocationsMap" center={position} zoom={7}>
      <TileLayer
        url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
        attribution="Esri | NCM"
      />
      {
        locations.map((l,i) => (
          <Marker position={l.position} onClick={() => openLocation(l)} key={l.id}></Marker>
        ))
      }
    </Map>
)}
